import React, { Fragment } from 'react';
import { resolve } from 'library/helpers/path-resolver';
import withConfig from 'util/hoc/with-config';
import ScrollAnimation from 'library/util/scroll';

class HeaderFour extends React.Component {
  handleScroll = () => {
    const scrollTop = window.scrollY;
    const innerHeight = window.innerHeight;
    const scrollTime = Math.abs((scrollTop - innerHeight) / innerHeight) * 500;
    new ScrollAnimation(scrollTop, innerHeight, scrollTime, 'quad.easeInOut');
  }

  render() {
    const {
      configuration
    } = this.props;

    return (
      <Fragment>
        <h1>
          <small>
            { resolve(configuration, 'apps/pathways/configuration/onboarding_steps/results/header/sub', 'my')}
          </small>
          { resolve(configuration, 'apps/pathways/configuration/onboarding_steps/results/header/main', 'results')}
        </h1>
        <p>
          {
            resolve(
              configuration,
              `apps/pathways/configuration/onboarding_steps/results/description`,
              `Here are career recommendations based on the information you provided.`
            )
          }
        </p>

        <div className="pathways-start-header-content">
          <button onClick={this.handleScroll}>Get Started</button>
        </div>
      </Fragment>
    );
  }
}

export default withConfig(HeaderFour);
